import { apiClient } from './client'
import { API_ENDPOINTS } from '@/utils/constants'
import type { AuthEventsPage, AuthEventsQuery } from '@/types/authEvents'

export const authEventsApi = {
  /** Журнал входов и выходов пользователя, новые сверху (только админ) */
  listForUser: async (userId: number, params: AuthEventsQuery): Promise<AuthEventsPage> => {
    const response = await apiClient.get<AuthEventsPage>(API_ENDPOINTS.ADMIN.USER_AUTH_EVENTS(userId), {
      params,
    })

    return { data: response.data.data, meta: response.data.meta }
  },
}
